"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withShade = exports.withTint = exports.shade = exports.tint = exports.hexValue = exports.parseColor = void 0;

function parseColor() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof color !== 'string') {
    throw new TypeError('Color should be string!');
  }

  var hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);

  if (hexMatch) {
    return hexMatch.splice(1).map(function (c) {
      return parseInt(c, 16);
    });
  }

  var hexMatchShort = /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(color);

  if (hexMatchShort) {
    return hexMatchShort.splice(1).map(function (c) {
      return parseInt(c + c, 16);
    });
  }

  if (color.includes(',')) {
    return color.split(',').map(function (p) {
      return parseInt(p);
    });
  }

  throw new Error('Invalid color format! Use #ABC or #AABBCC or r,g,b');
}

exports.parseColor = parseColor;

function hexValue(components) {
  return '#' + components.map(function (c) {
    return "0".concat(c.toString(16).toUpperCase()).slice(-2);
  }).join('');
}

exports.hexValue = hexValue;

function tint(components, intensity) {
  return components.map(function (c) {
    return Math.round(c + (255 - c) * intensity);
  });
}

exports.tint = tint;

function shade(components, intensity) {
  return components.map(function (c) {
    return Math.round(c * intensity);
  });
}

exports.shade = shade;

exports.withTint = function (intensity) {
  return function (hex) {
    return tint(hex, intensity);
  };
};

exports.withShade = function (intensity) {
  return function (hex) {
    return shade(hex, intensity);
  };
};